import React, { useEffect, useMemo, useState } from "react"
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Table,
} from "reactstrap"
import eye from "../../../assets/images/icons/eye.svg"
import SearchIco from "../../../assets/images/icons/search.svg"
import Sliders from "../../../assets/images/icons/sliders.svg"
import NoData from "../../../assets/images/noData.svg"
import { Link } from "react-router-dom"
import { useLazyGetDashboardCompaniesQuery } from "store/api/reports/reports"
import { formatAmount } from "helpers/common"
import { useSelector } from "react-redux"

const allStatuses = ["Registration", "Agreement", "Offer", "Invested"]

const DashbordCompanies = () => {
  const [statuses, setStatuses] = useState([])
  const [selected, setSelected] = useState([...allStatuses])
  const [search, setSearch] = useState("")
  const [companyStatusOpen, setCompanyStatusOpen] = useState(false)
  const [filters, setFilters] = useState()
  const [companies, setCompanies] = useState([])
  const [stats, setStats] = useState(null)
  const [getResults, { isFetching }] = useLazyGetDashboardCompaniesQuery()
  const { currentUserMenuType } = useSelector((state) => state.common)

  const getList = async () => {
    try {
      if (selected.length <= 0) {
        setCompanies([])
        return
      }
      const { data } = await getResults({ statuses: selected }).unwrap()
      setCompanies(data.companies)
      setStats(data.stats)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  const applyFilters = () => {
    setFilters({ ...filters, statuses })
    setCompanyStatusOpen(false)
  }

  const handleChange = (item) => {
    setSelected((prevSelected) =>
      prevSelected.includes(item)
        ? prevSelected.filter((i) => i !== item)
        : [...prevSelected, item]
    )
  }

  useEffect(() => {
    const filtered = search
      ? allStatuses.filter((item) =>
          item.toLowerCase().includes(search.toLocaleLowerCase())
        )
      : [...allStatuses]
    setStatuses(filtered)
  }, [search])

  return (
    <React.Fragment>
      <div
        className={
          currentUserMenuType === "WEALTH_PARTNER"
            ? "company-table-wrapper"
            : "container-inner-right-box company-table-details"
        }
      >
        <div className="filter-section">
          <h4>Company Status</h4>
          <div className="filter">
            <Dropdown
              isOpen={companyStatusOpen}
              toggle={() => setCompanyStatusOpen(!companyStatusOpen)}
              direction="end"
            >
              <DropdownToggle size="lg">
                <img src={Sliders} alt="" />
              </DropdownToggle>
              <DropdownMenu>
                <div className="dropdown-item-section">
                  <div className="input-wrapper">
                    <img src={SearchIco} alt="" />
                    <Input
                      name="Search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Search"
                      type="text"
                    />
                  </div>
                  <div className="filter-reset">
                    <p onClick={() => setSelected([...statuses])}>
                      Select All{" "}
                    </p>
                    <p onClick={() => setSelected([])}>Clear All </p>
                  </div>
                  <div className="checkbox-section">
                    {statuses.map((item, index) => (
                      <FormGroup check key={`statuses_${index}`}>
                        <Input
                          type="checkbox"
                          id={item}
                          checked={selected.includes(item)}
                          value={item}
                          onChange={() => handleChange(item)}
                        />
                        <Label htmlFor={item} check>
                          {item}
                        </Label>
                      </FormGroup>
                    ))}
                  </div>
                  <div className="bottom-section">
                    <p
                      className="clos"
                      onClick={() => setCompanyStatusOpen(!companyStatusOpen)}
                    >
                      Close
                    </p>
                    <p className="done" onClick={applyFilters}>
                      Done
                    </p>
                  </div>
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        <div className="investor-table-wrapper ">
          <Table responsive>
            <thead>
              <tr>
                <th className="name">Investor Detail</th>
                <th className="action text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {companies.map((item, index) => (
                <tr key={`companies_${index}`}>
                  <td>{item.name}</td>
                  <td>
                    <div className="action-view text-center">
                      <Link to={`/investors/view/${item.id}`}>
                        <img src={eye} alt="" />
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {!isFetching && companies.length <= 0 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "250px",
              }}
            >
              <img
                src={NoData}
                style={{
                  maxWidth: "160px",
                }}
                alt="Record not found"
              />
              <h4
                style={{
                  color: "#000000",
                  fontSize: "16px",
                  fontWeight: "600",
                  marginTop: "15px",
                  marginBottom: "5px",
                  textAlign: "center",
                }}
              >
                {selected.length <= 0
                  ? "Please select at least 1 filter"
                  : "No Records Found"}
              </h4>
            </div>
          )}
        </div>
        {!isFetching && stats && selected.length > 0 && (
          <div
            className={
              currentUserMenuType === "WEALTH_PARTNER"
                ? "summery-details"
                : "summary-table-wrapper"
            }
          >
            <Table responsive>
              <thead>
                <tr>
                  <th className="name">Summary</th>
                  <th className="action text-center">Details</th>
                </tr>
              </thead>
              <tbody>
                {selected.includes("Registration") && (
                  <tr>
                    <td>Registration</td>
                    <td>
                      <div className="amount text-center">
                        {stats?.registrations || 0}
                      </div>
                    </td>
                  </tr>
                )}
                {selected.includes("Agreement") && (
                  <tr>
                    <td>Agreement</td>
                    <td>
                      <div className="amount text-center">
                        {stats?.agreements}
                      </div>
                    </td>
                  </tr>
                )}
                {selected.includes("Offer") && (
                  <tr>
                    <td>Offer</td>
                    <td>
                      <div className="amount text-center">
                        ₹ {formatAmount(stats?.offers)}
                      </div>
                    </td>
                  </tr>
                )}
                {selected.includes("Invested") && (
                  <tr>
                    <td>Invested</td>
                    <td>
                      <div className="amount text-center">
                        ₹ {formatAmount(stats?.invested)}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </React.Fragment>
  )
}

export default DashbordCompanies
